import type { ReactElement } from 'react';
import { useT } from '../../../../app/di';
import { Card } from '../../../../ui-kit/Card/Card';
import styles from './ApiKeysHelp.module.scss';

export interface ApiKeysHelpProps {
  /** Адрес сервера для агента. */
  serverUrl: string;
  guideUrl: string;
  skillUrl: string;
  /** KIT-UC-2: скил целиком со скриптом синхронизации. */
  skillZipUrl: string;
}

/** KIT-UC-1, KIT-UC-2: что дать агенту вместе с ключом — адрес, скил (и архивом) и справочник API. */
export function ApiKeysHelp({ serverUrl, guideUrl, skillUrl, skillZipUrl }: ApiKeysHelpProps): ReactElement {
  const { t } = useT();
  return (
    <Card title={t('identity.apiKeys.helpTitle')}>
      <div className="u-stack">
        <p>{t('identity.apiKeys.helpText')}</p>
        <p>
          {t('identity.apiKeys.serverUrl')}: <code className={styles.address}>{serverUrl}</code>
        </p>
        <ul className="u-bullets">
          <li>
            <a href={skillUrl} target="_blank" rel="noreferrer noopener">
              {t('identity.apiKeys.skill')}
            </a>
          </li>
          <li>
            <a href={skillZipUrl} download>
              {t('identity.apiKeys.skillZip')}
            </a>
          </li>
          <li>
            <a href={guideUrl} target="_blank" rel="noreferrer noopener">
              {t('identity.apiKeys.guide')}
            </a>
          </li>
        </ul>
      </div>
    </Card>
  );
}
